import FullPageLayout from "../../../templates/FullPageLayout";
import { Button, Col, Row, Card, Form, Switch } from "antd";
import { useForm } from "react-hook-form";
import { NeedHelp } from "../../../atoms/CustomIcons";
import { useEffect, useState } from "react";
import { InputField, SelectField } from "../../../atoms/FormFields";
import { AutoCompleteField } from "../../../atoms/FormFields/AutoComplete";
import { AddressComponent, Place } from "../../Company/ducks/types";
import { SelectFieldTags } from "../../../atoms/FormFields/SelectFieldTags";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import {
  getClientContacts,
  getPropertyDetails,
  getPropertyFormData,
} from "../ducks/actions";
import { updatePropertyById } from "../ducks/services";
import { SuccessMessage } from "../../../atoms/Toasts/SuccessMessage";
import { useNavigate } from "react-router-dom";
import { AxiosError, AxiosResponse } from "axios";
import { ErrorMessage } from "../../../atoms/Toasts/ErrorMessage";
import PropertyContact from "../Components/AddContact";
import PropertyClient from "../Components/AddClient";
import { onImageDelete, uploadUserImage } from "../../MyProfile/ducks/services";
import { RcFile } from "antd/es/upload";
import { SelectedClientType, SelectedContactType } from "../ducks/types";
import UploadPhoto from "../../../atoms/UploadPhoto";

interface FormValues {
  name: string;
  address: string;
  select_client: string;
  category_ids: string[];
  address_note: string;
  client_contact_id: string[];
  responsible_for_account: string;
}

export default function AddProperty() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const propertyId = pathSegments[pathSegments.length - 2];
  const [checklistFile, setChecklistFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [clientId, setClientId] = useState<string | null>(null);
  const [selectedContact, setSelectedContact] = useState<
    SelectedContactType[] | null
  >(null);
  const [useClientAddress, setClientAddress] = useState(false);
  const [googleAddress, setGoogleAddress] = useState<Place | null>(null);
  const [selectedClient, setSelectedClient] =
    useState<SelectedClientType | null>(null);
  const [propertyContact, setPropertyContact] = useState<
    { label: string; value: string }[]
  >([]);

  const propertyFormData = useAppSelector(
    (state) => state?.properties?.propertyFormData
  );
  const clientContactData = useAppSelector(
    (state) => state?.properties?.clientContactData
  );

  const propertyDetailData = useAppSelector(
    (state) => state?.properties?.propertyDetailData
  );

  const {
    control,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm<FormValues>();

  // local UI state to match UploadPhoto's API
  const [previewImage, setPreviewImage] = useState<{
    file: string;
    imagePreviewUrl: string | null;
  }>({ file: "", imagePreviewUrl: null });
  const [modalPreviewImage, setModalPreviewImage] = useState<{
    file: string;
    imagePreviewUrl: string | null;
  }>({ file: "", imagePreviewUrl: null });
  const [uploadModal, setUploadModal] = useState<boolean>(false);
  const [, setIsCropModalOpen] = useState<boolean>(false);

  const saveUpload = () => {
    // preserve existing behavior: inform parent we're loading while saving
    setLoading(true);
    setPreviewImage({ ...modalPreviewImage });
    setLoading(false);
    setUploadModal(false);
  };

  useEffect(() => {
    if (companyId) {
      dispatch(getPropertyFormData(companyId));
    }
  }, [companyId, dispatch]);

  useEffect(() => {
    if (clientContactData) {
      const dummyArray: { label: string; value: string }[] = [];
      clientContactData?.map(
        (data: { first_name: string; last_name: string; id: string }) =>
          dummyArray.push({
            label: `${data?.first_name ?? ""} ${data?.last_name ?? ""}`,
            value: data?.id,
          })
      );
      setPropertyContact(dummyArray);
    }
  }, [clientContactData]);

  const onSubmit = (val: FormValues) => {
    setLoading(true);

    let city = "";
    let state = "";
    let latitude = "";
    let longitude = "";
    if (googleAddress?.geometry?.location) {
      latitude = googleAddress?.geometry?.location.lat().toString() || "";
      longitude = googleAddress?.geometry?.location.lng().toString() || "";
    }
    googleAddress?.address_components?.forEach(
      (component: AddressComponent) => {
        if (component.types.includes("locality")) {
          city = component.long_name;
        }
        if (component.types.includes("administrative_area_level_1")) {
          state = component.short_name;
        }
      }
    );

    const payload = {
      name: val?.name,
      address: val?.address,
      city: city,
      state: state,
      is_property_billing_address: true,
      address_note: val?.address_note,
      category_ids: val?.category_ids,
      manager_id: val?.responsible_for_account,
      manager_name: val?.responsible_for_account
        ? propertyFormData?.managers?.find(
            (manager) => manager?.value === val?.responsible_for_account
          )?.label
        : undefined,
      manager_image_url: val?.responsible_for_account
        ? propertyFormData?.managers?.find(
            (manager) => manager?.value === val?.responsible_for_account
          )?.image
        : undefined,
      company_id: companyId,
      client_id: val?.select_client,
      client_contact_id: val?.client_contact_id,
      longitude: longitude,
      latitude: latitude,
    };
    console.log("payload", payload);
    // return;
    updatePropertyById(propertyId, payload)
      .then((res: AxiosResponse) => {
        if (checklistFile && res && propertyId) {
          uploadUserImage({
            owner_id: propertyId,
            image: checklistFile as File | RcFile,
            image_type: "property_image",
          })
            .then((res) => {
              if (res) {
                setLoading(false);
                SuccessMessage("Property updated");
                navigate(`/properties/${companyId}`);
              }
            })
            .catch((e: unknown) => {
              if (e instanceof AxiosError) {
                setLoading(false);
                ErrorMessage(
                  e?.response?.data?.error?.message ?? "Something went wrong"
                );
              } else {
                setLoading(false);
                ErrorMessage("Something went wrong");
              }
            });
        } else {
          setLoading(false);
          SuccessMessage("Property updated");
          navigate(`/properties/${companyId}`);
        }
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  useEffect(() => {
    if (propertyId) {
      dispatch(getPropertyDetails(propertyId));
    }
  }, [propertyId, dispatch]);

  useEffect(() => {
    if (propertyDetailData) {
      setValue("name", propertyDetailData?.data?.name ?? "");
      setValue("address", propertyDetailData?.data?.address ?? "");
      setValue("address_note", propertyDetailData?.data?.address_note ?? "");
      setValue("category_ids", propertyDetailData?.data?.category_ids ?? []);
      if (propertyDetailData?.data?.manager_id) {
        setValue(
          "responsible_for_account",
          propertyDetailData?.data?.manager_id ?? ""
        );
      }

      if (propertyDetailData?.data?.client_id) {
        const filteredClient: SelectedClientType | null =
          propertyFormData?.clients?.find(
            (client: { value: string }) =>
              client?.value === propertyDetailData?.data?.client_id
          ) ?? null;
        setSelectedClient(filteredClient);
        setClientId(propertyDetailData?.data?.client_id);
        setValue("select_client", propertyDetailData?.data?.client_id ?? "");

        if (
          propertyDetailData?.data?.latitude &&
          propertyDetailData?.data?.longitude
        ) {
          setGoogleAddress({
            formatted_address: propertyDetailData?.data?.address,
            geometry: {
              location: {
                lat: () => propertyDetailData?.data?.latitude ?? 0,
                lng: () => propertyDetailData?.data?.longitude ?? 0,
              },
            },
            address_components: [
              {
                long_name: propertyDetailData?.data?.city ?? "",
                short_name: propertyDetailData?.data?.city ?? "",
                types: ["locality"],
              },
              {
                long_name: propertyDetailData?.data?.state ?? "",
                short_name: propertyDetailData?.data?.state ?? "",
                types: ["administrative_area_level_1"],
              },
            ],
          });
        }
      }
    }
  }, [propertyDetailData, setValue, propertyFormData, dispatch]);

  useEffect(() => {
    if (
      propertyDetailData?.data?.propertiesContacts &&
      propertyDetailData?.data?.propertiesContacts?.length > 0
    ) {
      setTimeout(() => {
        if (clientContactData && clientContactData?.length > 0) {
          setValue(
            "client_contact_id",
            propertyDetailData?.data?.propertiesContacts?.map(
              (e: { client_contact_id: string }) => e?.client_contact_id
            ) ?? []
          );
          const filteredContact: SelectedContactType[] | null =
            clientContactData?.filter(
              (emp: { id: string }) =>
                Array.isArray(propertyDetailData?.data?.propertiesContacts) &&
                propertyDetailData?.data?.propertiesContacts.some(
                  (v: { client_contact_id: string }) =>
                    v?.client_contact_id === emp?.id
                )
            ) ?? null;
          setSelectedContact(filteredContact as SelectedContactType[] | null);
        }
      }, 1500);
    } else {
      setValue("client_contact_id", []);
      setSelectedContact(null);
    }
  }, [clientContactData, propertyDetailData, setValue]);

  useEffect(() => {
    if (propertyDetailData?.data?.client_id) {
      dispatch(
        getClientContacts(propertyDetailData?.data?.client_id as string)
      );
    }
  }, [propertyDetailData?.data?.client_id, dispatch]);

  function callMembersAPI() {
    if (propertyId) {
      dispatch(getPropertyDetails(propertyId));
    }
  }

  const useClientBilling = (checked: boolean) => {
    setClientAddress(checked);
    if (checked && selectedClient?.address) {
      setValue("address", selectedClient?.address);
      clearErrors("address");
      setGoogleAddress({
        formatted_address: selectedClient.address,
        geometry: {
          location: {
            lat: () => selectedClient?.latitude ?? 0,
            lng: () => selectedClient?.longitude ?? 0,
          },
        },
        address_components: [
          {
            long_name: selectedClient?.city ?? "",
            short_name: selectedClient?.city ?? "",
            types: ["locality"],
          },
          {
            long_name: selectedClient?.state ?? "",
            short_name: selectedClient?.state ?? "",
            types: ["administrative_area_level_1"],
          },
        ],
      });
    } else if (!checked) {
      setValue("address", "");
      setGoogleAddress(null);
    }
  };
  return (
    <FullPageLayout loading={loading}>
      <Form
        className="propertyForm"
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
        onKeyDown={(e) => {
          if (e.key === "Enter") e.preventDefault();
        }}
      >
        <Button className="btn-sm fixedTopBtn">
          <NeedHelp /> Need help?
        </Button>

        <div style={{ paddingBottom: 80 }}>
          <Row gutter={8} style={{ width: "672px" }}>
            <Col span={24}>
              <div
                className="title"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                <div>
                  <h2> Edit Property </h2>
                  <p>Property is a location where you schedule crew visits.</p>
                </div>
                {/* <Button
                  htmlType="button"
                  className="outlined-btn btn-sm"
                  type="primary"
                >
                  <UploadIcon /> Bulk upload
                </Button> */}
              </div>
            </Col>

            <Col span={24}>
              <Card>
                <PropertyClient
                  propertyClientData={propertyFormData?.clients}
                  control={control}
                  companyId={companyId}
                  setClientId={setClientId}
                  selectedClient={selectedClient}
                  setSelectedClient={setSelectedClient}
                  setValue={setValue}
                />
              </Card>
              <Card>
                <Row gutter={20}>
                  <Col span={24} style={{ marginBottom: "16px" }}>
                    <h4> Property details </h4>
                  </Col>
                  <Col span={24} style={{ marginBottom: "24px" }}>
                    <UploadPhoto
                      saveUpload={saveUpload}
                      loading={false}
                      uploadModal={uploadModal}
                      setUploadModal={setUploadModal}
                      previewImage={previewImage}
                      checklistFile={checklistFile}
                      modalPreviewImage={modalPreviewImage}
                      setChecklistFile={setChecklistFile}
                      setPreviewImage={setPreviewImage}
                      setModalPreviewImage={setModalPreviewImage}
                      setIsCropModalOpen={setIsCropModalOpen}
                      infoTextUploader="The picture helps others identify this property. It’s optional."
                      imageUploaded={propertyDetailData?.data?.image_url}
                      onImageDelete={() => {
                        onImageDelete(
                          setLoading,
                          SuccessMessage,
                          callMembersAPI,
                          ErrorMessage,
                          propertyDetailData?.data?.image_url
                            ? propertyDetailData?.data?.image_id
                            : undefined
                        );
                      }}
                    />
                  </Col>
                  <Col span={24}>
                    <InputField
                      fieldName="name"
                      label="Property name"
                      control={control}
                      defaultValue=""
                      iProps={{
                        placeholder: "Enter property name",
                      }}
                      isRequired
                      rules={{
                        required: "Property name is required.",
                      }}
                      validate={errors.name && "error"}
                      validMessage={errors.name && errors.name.message}
                    />

                    <AutoCompleteField
                      fieldName="address"
                      label="Property address"
                      control={control}
                      defaultValue=""
                      iProps={{
                        placeholder: "Search address",
                      }}
                      onPlaceChange={(place: Place) => setGoogleAddress(place)}
                      isRequired
                      rules={{
                        required: "Property address is required.",
                      }}
                      validate={errors.address && "error"}
                      validMessage={errors.address && errors.address.message}
                    />

                    <div className="filterBox" style={{ marginBottom: "16px" }}>
                      <div className="switchBox">
                        <Switch
                          onChange={useClientBilling}
                          checked={useClientAddress}
                        />
                        Property and client’s billing addresses match
                      </div>
                    </div>

                    <InputField
                      fieldName="address_note"
                      label="Address note"
                      control={control}
                      defaultValue=""
                      iProps={{
                        placeholder: "Enter address note name",
                      }}
                      // isRequired
                      // rules={{
                      //   required: "Address note is required.",
                      // }}
                      // validate={errors.address_note && "error"}
                      // validMessage={
                      //   errors.address_note && errors.address_note.message
                      // }
                    />
                  </Col>
                  <Col span={12}>
                    <SelectFieldTags
                      fieldName="category_ids"
                      label="Categories"
                      control={control}
                      selectOption={propertyFormData?.category}
                      iProps={{
                        placeholder: "Select categories",
                        mode: "multiple",
                      }}
                      className="bottom_0"
                    />
                  </Col>
                  <Col span={12}>
                    <SelectField
                      fieldName="responsible_for_account"
                      label="Responsible for account"
                      control={control}
                      selectOption={propertyFormData?.managers}
                      iProps={{
                        placeholder: "Select a manager",
                      }}
                      className="bottom_0"
                      tooltipTitle="A manager overseeing this account - either a salesperson or an account manager, depending on the stage."
                    />
                  </Col>
                </Row>
              </Card>
              <Card>
                <PropertyContact
                  propertyContact={propertyContact}
                  clientId={clientId}
                  companyId={companyId}
                  control={control}
                  clientContactData={clientContactData}
                  contactData={propertyDetailData?.data?.propertiesContacts}
                  selectedClient={selectedClient?.type}
                  setSelectedContact={setSelectedContact}
                  selectedContact={selectedContact}
                  setValue={setValue}
                  propertyId={propertyId}
                />
              </Card>
            </Col>
          </Row>

          <div className="fixed_btm_card">
            <Card>
              <div className="centered">
                <Button
                  htmlType="button"
                  className="outlined-btn"
                  onClick={() => navigate(`/properties/${companyId}`)}
                >
                  Cancel
                </Button>
                <Button htmlType="submit" type="primary" className="mint-btn">
                  Save & close
                </Button>
              </div>
            </Card>
          </div>
        </div>
      </Form>
    </FullPageLayout>
  );
}
